<!-- Body Content-->
<div class="pt-3 px-2 md:px-4 pb-8" aria-label="task-list-container">
  <div class="flex md:mb-3" aria-label="task-list-header">
    <div class="w-6">
      <h1 class="text-base md:text-lg text-900 flex align-items-center mb-0" data-cy="title" aria-label="task-list-title">{{ 'TASK_LIST.HEADER_LABEL'
        | translate }}
        <!-- <i class="fa fa-question-circle font-light text-xl text-600 cursor-pointer ml-2" tooltipStyleClass="text-xs" [pTooltip]="'TASK_LIST.TOOL_TIP' | translate"></i> -->
        <a class="inline-flex align-items-center py-1 px-2 border-round text-white text-xs ml-2 bg-purple-600"
          href="https://guides.unifiedfitnessplatform.ai/showcase/cluiezsq402nn4l5294h6gu1h" target="_blank" aria-label="help-guide-link" data-testid="help-guide-link">
          <img width="14" src="/assets/img/interactive-icon.svg" alt="Icon" />
          <span class="ml-2 hidden md:inline-block">Help Guide for {{ 'TASK_LIST.HEADER_LABEL' | translate }}</span>
        </a>
      </h1>
    </div>
    <div class="w-6">
      <div class="hidden xl:flex align-items-center justify-content-end">
        <div class="md:w-13rem" aria-label="staff-selector">
          <multi-select-staff [selected]="selectedStaffIds"
            (selectStaffEvent)="selectedStaffsData($event)"></multi-select-staff>
        </div>
        <div (click)="showTaskCreate = true" class="ml-2 hidden md:inline-block">
          <p-button icon="fa fa-plus" label="{{ 'TASK_LIST.CREATE-TASK' | translate }}"
            styleClass="text-sm" aria-label="create-task-button"></p-button>
        </div>
        <div (click)="showTaskCreate = true" class="ml-2 md:hidden">
          <p-button icon="fa fa-plus" aria-label="create-task-button-mobile" ></p-button>
        </div>

      </div>

      <div class="flex align-items-center justify-content-end xl:hidden">
        <div (click)="showTaskCreate = true">
          <button class="w-2rem h-2rem mr-2" pButton pRipple label=""
            icon="fa fa-plus" aria-label="create-task-button-mobile" ></button>
        </div>
        <button class="w-2rem h-2rem surface-0 text-primary shadow-none" pButton pRipple label="" icon="fa fa-filter"
          pStyleClass="#showTaskFilters" enterFromClass="hidden" enterActiveClass="fadein" leaveToClass="hidden"
          leaveActiveClass="fadeout" [hideOnOutsideClick]="true" aria-label="filter-button"></button>
      </div>
    </div>
  </div>

  <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none mt-2 md:my-0">

  <!-- For Mobile View -->
  <div id="showTaskFilters" class="hidden surface-0 shadow-2 md:my-2 border-round p-3" aria-label="mobile-filters">
    <multi-select-staff [selected]="selectedStaffIds"
      (selectStaffEvent)="selectedStaffsData($event)"></multi-select-staff>
  </div>
  <!-- For Mobile View -->


  <div class="flex justify-content-between align-items-end md:pt-1 mb-2 xl:mb-0" aria-label="task-filters">

    <!-- For Desktop -->
    <div class="hidden xl:flex align-items-center w-7 md:w-10 text-sm white-space-nowrap" aria-label="task-categories">
      <!-- Active State -->

      <!-- Active State -->
      <a (click)="getTaskByParams(taskTypesCategory[0])" [ngClass]="{
          'font-bold opacity-100 border-bottom-3 border-primary': step === 'today'
        }" class="no-underline opacity-70 px-3 pb-2 mr-1 hover:text-800 cursor-pointer" aria-label="due-today-filter" data-testid="due-today-filter">{{ 'TASK_LIST.DUE_TODAY' | translate }}
      </a>
      <a (click)="getTaskByParams(taskTypesCategory[1])" [ngClass]="{
          'font-bold opacity-100 border-bottom-3 border-primary':
            step === 'overdue'
        }" class="no-underline opacity-70 px-3 pb-2 mr-1 hover:text-800 cursor-pointer" aria-label="overdue-filter" data-testid="overdue-filter">{{ 'TASK_LIST.OVER_DUE' | translate }}</a>
      <a (click)="getTaskByParams(taskTypesCategory[2])"
        class="no-underline px-3 pb-2 mr-1 opacity-70 hover:text-800 cursor-pointer" [ngClass]="{
           'font-bold opacity-100 border-bottom-3 border-primary':
             step === 'scheduled'
         }" aria-label="all-due-tasks-filter" data-testid="all-due-tasks-filter">{{ 'TASK_LIST.ALL_DUE_TASKS' | translate }}
      </a>
      <a (click)="getTaskByParams(taskTypesCategory[3])" [ngClass]="{
          'font-bold opacity-100 border-bottom-3 border-primary': step === 'tomorrow'
        }" class="no-underline opacity-70 px-3 pb-2 mr-1 hover:text-800 cursor-pointer" aria-label="tomorrow-filter" data-testid="tomorrow-filter">{{ 'TASK_LIST.TOMORROW' | translate }}
      </a>
      <a (click)="getTaskByParams(taskTypesCategory[4])" [ngClass]="{
          'font-bold opacity-100 border-bottom-3 border-primary': step === 'in 1 week'
        }" class="no-underline opacity-70 px-3 pb-2 mr-1 hover:text-800 cursor-pointer" aria-label="this-week-filter" data-testid="this-week-filter">{{ 'TASK_LIST.THIS_WEEK' | translate }}
      </a>
      <a (click)="getTaskByParams(taskTypesCategory[5])" [ngClass]="{
          'font-bold opacity-100 border-bottom-3 border-primary': step === 'In 2 Weeks'
        }" class="no-underline opacity-70 px-3 pb-2 mr-1 hover:text-800 cursor-pointer" aria-label="next-week-filter" data-testid="next-week-filter">{{ 'TASK_LIST.NEXT_WEEK' | translate }}
      </a>
      <a (click)="getTaskByParams(taskTypesCategory[6])"
        class="no-underline opacity-70 px-3 pb-2 hover:text-800 cursor-pointer" [ngClass]="{
          'font-bold opacity-100 border-bottom-3 border-primary': step === 'completed'
        }" aria-label="completed-filter" data-testid="completed-filter">{{ 'TASK_LIST.COMPLETED' | translate }}
      </a>
    </div>
    <!-- For Desktop -->

    <!-- For Mobile as Selectbox -->
    <div class="xl:hidden">
      <p-select (onChange)="changeTaskParam($event)" [options]="taskTypesCategory" [(ngModel)]="selectedTaskType"
        optionLabel="name" filterBy="name"
        styleClass="border-none shadow-none surface-100 font-bold flex align-items-center py-0"
        dropdownIcon="fa fa-caret-down text-primary -mt-1 -ml-2" aria-label="task-type-dropdown" data-testid="task-type-dropdown">
        <ng-template pTemplate="selectedItem">
          <div class="text-sm text-primary" *ngIf="selectedTaskType">
            {{ 'TASK_LIST.' + selectedTaskType.name | translate }}
          </div>
        </ng-template>
        <ng-template let-taskType pTemplate="item">
          <div class="text-sm">
            {{ 'TASK_LIST.' + taskType.name | translate }}
          </div>
        </ng-template>
      </p-select>
    </div>
    <!-- For Mobile as Selectbox -->

    <!-- Filter -->
    <p-popover #filterList styleClass="w-22rem md:w-25rem" aria-label="filter-panel">
      <ng-template #content>
        <i (click)="filterList.hide($event)"
          class="fa fa-times text-xl text-600 absolute right-0 top-0 cursor-pointer mt-3 mr-3" aria-label="close-filter" data-testid="close-filter"></i>
        <!-- Dropdown Content -->
        <div class="mb-3" aria-label="filter-content">
          <!-- Task Type -->
          <h4 class="font-medium text-700 text-xs mb-2 block uppercase" aria-label="task-type-label">
            {{ 'TASK_LIST.TASK_TYPE' | translate }}
          </h4>
          <div class="p-buttonset mb-4" aria-label="task-type-buttons">

            <button pButton pRipple [label]="'TASK_LIST.CALL' | translate" icon="fa fa-phone" [ngClass]="{
                'bg-primary': typeFilter?.includes('call')
              }" (click)="setFilter('type', 'call')"
              class="p-button-secondary border-right-1 border-white text-xs md:text-sm" aria-label="call-filter" >
            </button>

            <button pButton pRipple [label]="'TASK_LIST.TOUR' | translate" icon="fa fa-map-marker-alt" [ngClass]="{
                'bg-primary':  typeFilter?.includes('tour')
              }" (click)="setFilter('type', 'tour')"
              class="p-button-secondary border-right-1 border-white text-xs md:text-sm" aria-label="tour-filter">
            </button>
          </div>
          <!-- Task Type -->

          <!-- Due Date -->
          <form [formGroup]="customFilterForm" aria-label="due-date-form">
            <h4 class="font-medium text-700 text-xs mb-2 block uppercase" aria-label="due-date-label">
              {{ 'TASK_LIST.DUE_DATE' | translate }}
            </h4>
            <div class="mb-4 flex align-items-center" aria-label="date-range">
              <p-datepicker [showIcon]="true" formControlName="dueDateFrom"
                placeholder="{{ 'TASK_LIST.SELECT_DATE' | translate }}" inputStyleClass="text-sm" aria-label="start-date"></p-datepicker>
              <div class="mx-3">To</div>
              <p-datepicker appendTo="body" [showIcon]="true" formControlName="dueDateTo"
                placeholder="{{ 'TASK_LIST.SELECT_DATE' | translate }}" inputStyleClass="text-sm" aria-label="end-date"></p-datepicker>
            </div>
            <!-- Due Date -->

            <!-- Task Category -->
            <h4 class="font-medium text-700 text-xs mb-2 block uppercase" aria-label="task-category-label">
              {{ 'TASK_LIST.TASK_CAT' | translate }}
            </h4>

            <task-category [multi]="true" [formGroup]="customFilterForm" [controlName]="TaskCategory"
              styleClass="w-full text-sm align-items-center" placeHolder="{{ 'TASK_LIST.TASK_CATEGORY' | translate }}" aria-label="task-category-selector">
            </task-category>
            <!-- Task Category -->
          </form>
        </div>
        <!-- Dropdown Content -->

        <!-- Dropdown Footer -->
        <div class="border-top-1 border-300 py-2 px-3 flex align-items-center justify-content-between -mb-3 -mx-3" aria-label="filter-footer">
          <p-button label="{{ 'ADMIN.COMMON.RESET_FILTERS' | translate }}" styleClass="p-button-link text-sm"
            pStyleClass="@grandparent" (click)="resetFilter(); filterList.hide($event)" enterFromClass="hidden"
            enterActiveClass="scalein" leaveToClass="hidden" leaveActiveClass="fadeout" aria-label="reset-filters">
          </p-button>
          <button pButton pRipple label="{{ 'TASK_LIST.APPLY_FILTER' | translate }}" class="text-sm"
            pStyleClass="@grandparent" enterFromClass="hidden" enterActiveClass="scalein" leaveToClass="hidden"
            leaveActiveClass="fadeout" (click)="applyFilter(); filterList.hide($event)" aria-label="apply-filters"></button>
        </div>
        <!-- Dropdown Footer -->
      </ng-template>
    </p-popover>

    <div class="hidden md:inline-block" (click)="filterList.toggle($event)">
      <button pButton pRipple type="button" label="More Filters" class="p-button-text text-sm shadow-none" icon="fa fa-filter" aria-label="more-filters"></button>
    </div>
    <div class="md:hidden" (click)="filterList.toggle($event)">
      <button pButton pRipple type="button" class="p-button-text text-sm shadow-none" icon="fa fa-filter" aria-label="more-filters-mobile"></button>
    </div>
    <!-- Filter -->

  </div>


  <div class="card relative surface-0 shadow-2 border-round" aria-label="task-list-card">
    <div class="hidden align-items-center justify-content-between p-2 border-bottom-1 border-300">
      <!-- Left Side -->
      <div class="xl:w-4 hidden xl:block">
      </div>
      <!-- Left Side -->

      <!-- Right Side -->
      <div class="w-12 xl:w-8 flex flex-wrap xl:flex-nowrap align-items-center justify-content-end">
        <!-- View Type -->
        <div class="p-buttonset mr-3">
          <!-- <button class="text-sm font-normal" pButton pRipple><i class="fa fa-list"></i><span class="ml-2 hidden xl:inline">{{'TASK_LIST.LIST_VIEW' | translate}} </span></button> -->
          <!-- <button class="p-button-outlined p-button-secondary text-sm" pButton pRipple><i class="fa fa-calendar"></i><span class="ml-2 hidden xl:inline">{{'TASK_LIST.CALENDER_VIEW' | translate}} </span></button> -->
        </div>
        <!-- View Type -->


      </div>
      <!-- Right Side -->
    </div>

    <!-- Table Options -->
    <div *ngIf="showBulkActionBar" class="flex align-items-center flex-wrap text-sm mt-1 xl:mt-3" aria-label="bulk-actions">
      <!-- Checkbox -->
      <div class="ml-3 my-2 flex align-items-center mr-2 md:mr-3 white-space-nowrap" aria-label="selected-count">
        <span>{{ selectedClient.size }}
          {{ 'TASK_LIST.CLIENTS_SELECTED' | translate }}
        </span>
        <i class="fa fa-arrow-right ml-3 hidden xl:inline"></i>
      </div>

      <button pButton pRipple type="button" label="{{ 'TASK_LIST.CREATE-TASK' | translate }}"
        class="p-button-text text-xs md:text-sm mr-3 my-2" icon="fa fa-list"
        (click)="showTaskCreateMultiple()" aria-label="create-multiple-tasks-button"></button>

      <button pButton pRipple type="button" label="{{ 'TASK_LIST.DELETE_TASK' | translate }}"
        class="p-button-text text-xs md:text-sm mr-3 my-2" icon="fa fa-trash-alt" (click)="showDeleteTaskPopup = true"
        aria-label="delete-task-button"></button>

      <button [disabled]="currentUserDetails && currentUserDetails['can_admin_client_profiles'] === 'false'" pButton pRipple type="button" label="{{ 'TASK_LIST.RE_ASSIGN' | translate }}"
        class="p-button-text text-xs md:text-sm mr-3 my-2" icon="fa fa-calendar-alt"
        (click)="reassignTasksPopup = true" aria-label="reassign-tasks-button"></button>
    </div>

    <app-data-grid [columnData]="tableData" [totalRecords]="totalRecordLength" [columns]="columns" [loading]="loading"
      (loadNextData)="fetchNextSetData($event)" [EmptyState]="emptyStateComponent$" [selectable]="selectAllTaskListData"
      (emitValue)="handleEvent($event)" (onAction)="refreshData($event)"
      (emitSelectValue)="handleSelectAll($event)" [resizableColumns]="true" [columnResizeMode]="'expand'"
      aria-label="task-data-grid" [gridName]="'task-list'"></app-data-grid>
  </div>
  <!-- Body Content-->

  <task-create [visible]="showTaskCreate" (hide)="HideTaskCreate($event)">
    <task-create [cltIds]="selectedClientIds" [visible]="showTaskMultiple" (hide)="HideTaskCreateMulti($event)">
    </task-create></task-create>
</div>

<client-info-sidebar *ngIf="showClientSidebar" [showClientSidebar]="showClientSidebar" [activeClientId]="activeClientId"
  (closeSidebar)="closeSidebar($event)" aria-label="client-info-sidebar">
</client-info-sidebar>

<!-- Complete All Tasks Modal  -->
<p-dialog [(visible)]="showDeleteTaskPopup" [resizable]="false" appendTo="body" [modal]="true"
  [breakpoints]="{'767px': '100vw'}" [style]="{width: '550px'}" styleClass="no-header-modal" aria-label="delete-tasks-dialog">

  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">

    <!-- Content -->
    <div class="relative text-center p-5" aria-label="delete-tasks-content">

      <div class="fa fa-times text-xl opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer"
        (click)="showDeleteTaskPopup = false" aria-label="close-delete-dialog" data-testid="close-delete-dialog"></div>
      <i class="fa-solid fa-info-circle p-error text-7xl" aria-label="warning-icon"></i>
      <h4 class="text-lg mt-5 mb-3" aria-label="delete-tasks-title">{{ ( allSelected ? 'TASK_LIST.DELETE_INFO_ALL' : 'TASK_LIST.DELETE_INFO') |
        translate : {count : selectedClient.size} }}</h4>
      <p class="text-600 text-sm mb-0" aria-label="delete-tasks-message">{{ ( allSelected ? 'TASK_LIST.DELETE_CONT' : 'TASK_LIST.DELETE_CONT_ALL') |
        translate : {count : selectedClient.size} }}</p>

    </div>
    <!-- Content -->

    <!-- Footer -->
    <div class="flex align-items-center justify-content-between border-top-1 border-300 p-3" aria-label="delete-tasks-footer">
      <p-button [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
        styleClass="p-button-secondary p-button-link no-underline text-sm" (click)="showDeleteTaskPopup = false"
        aria-label="cancel-delete-button">
      </p-button>
      <p-button [label]="'TASK_LIST.BTN_DELETE' | translate" [loading]="disableDeleteBtn" styleClass="text-sm"
        (click)="deleteAllTasks()" aria-label="confirm-delete-button"></p-button>
    </div>
    <!-- Footer -->

  </ng-template>

</p-dialog>
<!-- Complete All Tasks Modal -->


<!-- Reassign Tasks Modal  -->
<p-dialog [(visible)]="reassignTasksPopup" [resizable]="false" appendTo="body" [modal]="true"
  [breakpoints]="{'991px': '100vw'}" [style]="{width: '550px'}" styleClass="no-header-modal overflow-visible" aria-label="reassign-tasks-dialog">

  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">

    <!-- Header -->
    <div
      class="p-3 sticky top-0 left-0 w-full surface-0 z-1 flex align-items-center justify-content-between border-bottom-1 border-300" aria-label="reassign-header">
      <h2 class="text-sm mb-0" aria-label="reassign-title">{{'TASK_LIST.REASSIGN_INFO' | translate : { count:selectedClient.size } }}</h2>
      <i class="fa fa-times text-xl text-600 cursor-pointer" (click)="reassignTasksPopup = false" aria-label="close-reassign-dialog"></i>
    </div>
    <!-- Header -->

    <!-- Content -->
    <div class="p-3 surface-100" aria-label="reassign-content">

      <!-- Message -->
      <div class="-mx-3 -mt-5">
        <p-message severity="info" icon="fa fa-info-circle" data-testid="info-message" aria-label="info-message">
            {{'TASK_LIST.REASSIGN_INFO_ALL' | translate : { count:selectedClient.size } }}
        </p-message>
      </div>
      <!-- Message -->

      <div class="surface-0 border-round p-3 shadow-2" aria-label="staff-selector-section">
        <div class="h-7rem">
          <label class="font-medium text-700 text-xs mb-2 block uppercase" aria-label="reassign-to-label">{{ 'TASK_LIST.RE_ASSIGN_TO' | translate
            }}</label>
          <staff-selector [formGroup]="changeSessionOwnerForm" [controlName]="SessionOwnerFormControl"
            [styleClass]="'text-sm border-0'" [placeHolder]="'common.PLACEHOLDER.SELECT' | translate"
            [filterstaff]="_sessionOwner" aria-label="staff-selector">
          </staff-selector>
          <app-error-msg *ngIf="SessionOwnerFormControl.touched && SessionOwnerFormControl.invalid"
            [errors]="SessionOwnerFormControl.errors" [fieldLabel]=" 'TASK_LIST.RE_ASSIGN_TO' | translate">
          </app-error-msg>
        </div>
      </div>

    </div>
    <!-- Content -->

    <!-- Footer -->
    <div
      class="p-3 sticky bottom-0 left-0 w-full surface-0 z-1 flex align-items-center justify-content-between border-top-1 border-300" aria-label="reassign-footer">
      <p-button label="Cancel" styleClass="p-button-link text-sm" (click)="reassignTasksPopup = false"
        aria-label="cancel-reassign-button"></p-button>
      <p-button label="Save" [loading]="disableReassigneBtn" styleClass="text-sm"
        (click)="reassignAllTasks()" aria-label="save-reassign-button"></p-button>
    </div>
    <!-- Footer -->

  </ng-template>

</p-dialog>
<!-- Reassign Tasks Modal -->